<script lang="ts" setup>
import { ButtonInput, Input } from '@brighterly/lib-lumee-ui'

import { useLessonRoomStore } from '@stores/lesson-room'

import { useLessonRoomChatView } from '@hooks/lesson-room/lesson-room-chat-view.hook'

import qaConfig from '@config/qa.json'

import LessonRoomPopup from '@Molecules/LessonRoom/LessonRoomPopup.vue'
import LessonRoomChatMessage from '@Molecules/LessonRoom/LessonRoomChatMessage.vue'

defineOptions({
  name: 'LessonRoomChat',
})

const lessonRoomStore = useLessonRoomStore()
const { draft, toggleChat, submitMessage } = useLessonRoomChatView()
</script>

<template>
  <LessonRoomPopup
    v-if="lessonRoomStore.isChatOpen"
    title="Chat"
    @close="toggleChat"
  >
    <div class="lesson-room-chat">
      <div class="lesson-room-chat__messages">
        <LessonRoomChatMessage
          v-for="(message, index) in lessonRoomStore.getChatMessages"
          :key="index"
          :message="message"
        />
        <div ref="messagesEnd" />
      </div>

      <form
        class="lesson-room-chat__controls"
        @submit.prevent="submitMessage"
      >
        <Input
          v-model="draft"
          placeholder="Send a message"
          :data-qa="qaConfig.attributes.inputChat"
        >
          <template #action>
            <ButtonInput
              text="Send"
              :disabled="!draft.trim()"
              :data-qa="qaConfig.attributes.buttonChatSubmit"
              @click="submitMessage"
            />
          </template>
        </Input>
      </form>
    </div>
  </LessonRoomPopup>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/LessonRoom/LessonRoomChat.scss" />